/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ApiTagList, Pagination } from '../../data/interfaces'
import {
    FETCH_API_TAGS_REQUEST, FETCH_API_TAGS_SUCCESS, FETCH_API_TAGS_FAILURE, TagsActions
} from '../types/tags'

interface TagsState {
    loading: boolean,
    tagList: ApiTagList,
    error: string,
}

const initialState: TagsState = {
    loading: true,
    tagList: { count: 0, list: [], pagination: {} as Pagination },
    error: ''
}

const apiTagsReducer = (state = initialState, action: TagsActions) => {
    switch (action.type) {
        case FETCH_API_TAGS_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }
        case FETCH_API_TAGS_SUCCESS:
            return {
                ...state,
                loading: false,
                tagList: action.payload,
                error: ''
            }
        case FETCH_API_TAGS_FAILURE:
            return {
                ...state,
                loading: false,
                tagList: { count: 0, list: [], pagination: null },
                error: action.payload
            }
        default: return state
    }
}

export default apiTagsReducer;
